const generateQueryParams = (
  queryAuthParams: Record<string, any> | undefined,
  url: string
) => {
  if (queryAuthParams) {
    const {
      onlineApplicationId: id,
      recurlyAccountId: accountId,
      ...qparams
    } = queryAuthParams;
    const qs = new URLSearchParams({
      id,
      accountId,
      ...qparams,
    });

    return `${url}?${qs}`;
  }

  return url;
};

export default generateQueryParams;
